
import React, { Component } from 'react';
import PropTypes from 'prop-types';
class StickyMenu extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            staticMenuHeight: "0px"
        };
        this.checkSticky = this.checkSticky.bind(this);
    }
    componentDidMount() {
        window.addEventListener("scroll", this.checkSticky);
        var staticMenuHeight = `${this.myStaticMenu.offsetHeight}px`;
        this.setState({
            staticMenuHeight: staticMenuHeight
        })
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.checkSticky);

    }
    checkSticky() {
        var scrollTop = (document.body.scrollTop || document.documentElement.scrollTop);
        var menuTop = Math.max(65 - scrollTop, 0);
        this.setState({
            menuTop: menuTop
        });
    }
    render() {
        return (
            <React.Fragment>
                <div ref={input => { this.myStaticMenu = input }} className="sticky-menu" style={{ top: this.props.withStickyHeader ? "65px" : this.state.menuTop }}>
                    {this.props.children}
                </div>
                <div className="stats-spacing" style={{ marginTop: this.props.withStickyHeader ? "0px" : this.state.staticMenuHeight }}></div>
            </React.Fragment>
        );
    }
}
StickyMenu.propTypes = {
    withStickyHeader: PropTypes.bool.isRequired
}
export default StickyMenu;


// WEBPACK FOOTER //
// ./src/components/common/stickymenu.jsx